import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AnimaloutcomeComponent } from './animaloutcome/animaloutcome.component';
import {SharedService} from './shared.service';
import {HttpClientModule} from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { OutcomemessageComponent } from './outcomemessage/outcomemessage.component';

@NgModule({
  declarations: [
    AppComponent,
    AnimaloutcomeComponent,
    HeaderComponent,
    FooterComponent,
    OutcomemessageComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgxMaskDirective, NgxMaskPipe
    
  ],
  providers: [SharedService, provideNgxMask()],
  bootstrap: [AppComponent]
})
export class AppModule { }
